var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 96,
    viewBox: "0 0 92 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 91,
    height: 96,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8223_24497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5911 66.3336L43.5891 79.3021C45.2255 80.2325 46.7743 80.2325 48.44 79.3021L71.4087 66.3336C74.0973 64.8215 75.5 63.2803 75.5 59.1222V36.0927C75.5 33.0686 74.3893 31.1786 71.9348 29.7829L51.2454 18.0936C47.7094 16.0873 44.2904 16.0873 40.7545 18.0936L20.0944 29.7829C17.6104 31.1786 16.5 33.0686 16.5 36.0927V59.1222C16.5 63.2803 17.9319 64.8215 20.5911 66.3336ZM23.2211 62.4953C21.5262 61.5648 20.9418 60.576 20.9418 58.9768V37.0232L43.7061 49.9627V74.0973L23.2211 62.4953ZM68.8081 62.4953L48.2939 74.0973V49.9627L71.0581 37.0232V58.9768C71.0581 60.576 70.4736 61.5648 68.8081 62.4953ZM46.0145 45.8919L23.4549 33.1849L32.4846 28.0382L55.0442 40.8033L46.0145 45.8919ZM59.7492 38.1572L37.1017 25.4212L42.7124 22.2517C44.9626 20.9723 47.0374 20.9433 49.3168 22.2517L68.5742 33.1849L59.7492 38.1572Z",
    fill: "#DDDDE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8223_24497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 64,
    fill: "white",
    transform: "translate(16.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.ad13e65a71ca853f5fe8534559d8c0bd.svg";
export { ForwardRef as ReactComponent };